import cogoToast from "cogo-toast";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import GoogleIcon from "../../assets/googleicon.png";
import OrLine from "../../assets/orline.svg";
import Button from "../../components/Button";
import Icon from "../../components/Icon";
import Input from "../../components/Input";
import { ComposeComponent } from "../../utils/composeComponents";

const AuthTitle = styled.div`
  font-family: Futura;
  font-weight: bold;
  font-size: 30px;
`;

const WithGoogle = styled(Button)`
  background-color: #535ca5;
  border: 0px;
`;

// const WithFacebook = styled(Button)`
//     background-color: #E8E8E8;
//     border:0px;
//     padding-left:30px;
//     padding-right:30px;
//     margin-left:20px
// `

const InputTitle = styled.div`
  font-size: 18px;
  color: #535ca5;
  margin-bottom: 10px;
`;

const SignInButton = styled(Button)`
  padding-left: 40px;
  padding-right: 40px;
`;

const AuthInput = styled(Input)`
  background: #e8e8e8;
  border: 0px;
  height: 40px;
`;

const AuthInputAtom = ({ title, type, formObj = {}, ...props }) => {
  return (
    <div style={{ width: "100%" }} {...props}>
      <InputTitle>
        {title}
        <span style={{ color: "red" }}>*</span>
      </InputTitle>
      <AuthInput required="true" type={type} {...formObj} />
    </div>
  );
};

const AuthInputRow = ({ titles, types, propObjects }) => {
  if (!types)
    types = Array.isArray(titles) ? titles.map((e) => "text") : "text";
  if (!propObjects)
    propObjects = Array.isArray(titles) ? titles.map((e) => ({})) : {};
  return (
    <div className="row">
      {Array.isArray(titles) ? (
        titles.map((title, key) => (
          <AuthInputAtom
            title={title}
            type={types[key]}
            key={key}
            className="col"
            formObj={propObjects[key]}
          />
        ))
      ) : (
        <AuthInputAtom
          title={titles}
          type={types}
          className="col"
          formObj={propObjects}
        />
      )}
    </div>
  );
};

const CheckboxObject = ({ text }) => {
  return (
    <div style={{ width: "100%" }}>
      <input type="checkbox" style={{ borderRadius: "20px" }}></input>
    </div>
  );
};

const GoogleSignInButton = ComposeComponent(WithGoogle)(
  <>
    <Icon src={GoogleIcon} />
    <span className="ml-3">Sign in with Google</span>
  </>
);

const Line = () => <img src={OrLine} alt="OrLine" style={{ width: "100%" }} />;

const RedirectLink = ({ link, name, linkName }) => (
  <div style={{ position: "fixed", right: 20, top: 20, zIndex: "5" }}>
    {name}
    <Link style={{ color: "red", marginLeft: 10 }} to={link}>
      {linkName}
    </Link>
  </div>
);

const error = cogoToast.error;

export {
  AuthInputRow,
  CheckboxObject,
  GoogleSignInButton,
  AuthTitle,
  Line,
  SignInButton,
  RedirectLink,
  error,
};
